// import {format, utcToZonedTime} from "date-fns-tz";

import {add} from "date-fns/add";
import {format} from "date-fns/format";
import {differenceInDays} from "date-fns/differenceInDays";
import {UTCDate} from "@date-fns/utc";

export default function formatToParam(date: Date): string {
	const formattedDate = format(new UTCDate(date), "yyyy-MM-dd'T'HH:mm:ss.SSSSSS'Z'", {});
	return formattedDate;
}

export function periodToDays(period: number, periodUnit: string): number {
	const d = new Date();
	return Math.abs(differenceInDays(add(d, {
		[periodUnit]: period
	}), d));
}